import {capitalize as $5OpyM$capitalize} from "@minutemailer/utils";
import {useMemo as $5OpyM$useMemo, useState as $5OpyM$useState, useEffect as $5OpyM$useEffect} from "react";

function $993dbf0491e8dc65$export$2e2bcd8739ae039(str) {
    return str.replace(/-([a-z])/g, function(g) {
        return g[1].toUpperCase();
    });
}



const $0a9bcd879bdb366e$var$machines = {};
const $0a9bcd879bdb366e$var$proxyHandler = {
    get: (obj, prop)=>{
        if (typeof prop === "string" && prop.indexOf("is") === 0 && !(prop in obj)) {
            const state = prop.replace("is", "");
            return obj.isState.bind(obj, state.charAt(0).toLowerCase() + state.slice(1));
        }
        return obj[prop];
    }
};
function $0a9bcd879bdb366e$export$109b76af3ca3e5d5(name, id = null) {
    const machineName = name instanceof $0a9bcd879bdb366e$var$Machine ? name.name : name;
    let machine = $0a9bcd879bdb366e$var$machines[machineName];
    if (id) {
        const idName = `${machineName}.${id}`;
        machine = $0a9bcd879bdb366e$export$109b76af3ca3e5d5(idName);
        if (!machine) machine = $0a9bcd879bdb366e$export$aaa7fa18f8e9b2e8(machineName, null, id);
    }
    return machine;
}
class $0a9bcd879bdb366e$var$Machine {
    constructor(name, configuration, id = null, initialData = {}, sync = false){
        this.name = name;
        this.id = id;
        this.sync = sync;
        this.subscribers = [];
        this.configuration = configuration;
        this.transitions = this.configuration.transitions;
        this.state = {
            ...this.configuration.state,
            ...initialData
        };
        this.handlers = this.configuration.handlers;
        Object.entries(this.handlers).forEach(([name, func])=>{
            this[name] = (...args)=>func.apply(this, args);
        });
        Object.entries(this.transitions).forEach(([state])=>{
            this[state] = (...data)=>{
                this.input(state, data);
            };
        });
        return new Proxy(this, $0a9bcd879bdb366e$var$proxyHandler);
    }
    getMachine(machine) {
        return $0a9bcd879bdb366e$export$109b76af3ca3e5d5(machine);
    }
    setSync(sync) {
        this.sync = sync;
    }
    getParent() {
        const [parent] = this.name.split(".");
        if (parent !== this.name) return parent;
        return null;
    }
    getParentMachine() {
        const parent = this.getParent();
        if (parent) return $0a9bcd879bdb366e$export$109b76af3ca3e5d5(parent);
        return null;
    }
    getParentAttr() {
        const [parent] = this.name.split(".");
        if (parent !== this.name) return parent;
        return this.name;
    }
    getChildAttr() {
        const [parent, child] = this.name.split(".");
        if (parent !== this.name) return child;
        return this.name;
    }
    getChildMachines() {
        const parent = this.getParent();
        if (!parent) return Object.keys($0a9bcd879bdb366e$var$machines).filter((name)=>name.indexOf(`${this.name}.`) > -1);
        return [];
    }
    isParent() {
        const childMachines = this.getChildMachines();
        return childMachines.length > 0;
    }
    isChild() {
        return this.getParent() !== null;
    }
    subscribe(cb) {
        if (!this.subscribers.includes(cb)) this.subscribers.push(cb);
        return {
            unsubscribe: ()=>{
                this.subscribers = this.subscribers.filter((subscribedCb)=>subscribedCb !== cb);
            }
        };
    }
    isState(state) {
        return state === this.state.current || state === (0, $993dbf0491e8dc65$export$2e2bcd8739ae039)(this.state.current);
    }
    transitionAllowed(currentState, action) {
        const transition = this.transitions[action];
        return transition && transition.from === currentState;
    }
    can(action) {
        return this.transitionAllowed(this.state.current, action);
    }
    input = (action, data)=>{
        const { current: current  } = this.state;
        if (!this.transitionAllowed(current, action)) return;
        const transition = this.transitions[action];
        this.setState(transition.to, data);
    };
    setData(data, silent = false) {
        this.setState(this.state.current, [
            data
        ], silent);
    }
    setState(state, data = [], silent = false) {
        const newData = data.length && typeof data[0] === "object" ? data[0] : {};
        const prevState = `${this.state.current}`;
        const newState = {
            ...newData
        };
        if (state !== prevState) newState.current = state;
        this.state = {
            ...this.state,
            ...newState
        };
        if (!silent) {
            this.emit(newState);
            if (prevState !== this.state.current) {
                const handler = `on${(0, $5OpyM$capitalize)((0, $993dbf0491e8dc65$export$2e2bcd8739ae039)(state))}`;
                if (handler in this) this[handler](...data);
            }
        }
    }
    emit(newData) {
        this.subscribers.forEach((cb)=>cb.call(null, newData, this.state));
        if (this.sync) {
            const parentMachine = this.getParentMachine();
            if (parentMachine) {
                const childAttr = this.getChildAttr();
                const parentAttr = this.getParentAttr();
                const data = {
                    ...this.state[childAttr]
                };
                const transition = `update${(0, $5OpyM$capitalize)(childAttr)}`;
                const items = [
                    ...parentMachine.state[parentAttr]
                ];
                const index = items.findIndex((item)=>item.id === data.id);
                if (index > -1) {
                    items[index] = {
                        ...items[index],
                        ...data
                    };
                    parentMachine[transition]({
                        [parentAttr]: items
                    });
                }
            }
        }
    }
    destroy() {
        $0a9bcd879bdb366e$var$machines[this.name] = null;
        delete $0a9bcd879bdb366e$var$machines[this.name];
    }
}
function $0a9bcd879bdb366e$export$aaa7fa18f8e9b2e8(name, configuration = {}, id = null) {
    if (!(name in $0a9bcd879bdb366e$var$machines)) $0a9bcd879bdb366e$var$machines[name] = new $0a9bcd879bdb366e$var$Machine(name, configuration, null);
    if (id) {
        const idName = `${name}.${id}`;
        const [parent, child] = name.split(".");
        let sync = false;
        let data = null;
        if (idName in $0a9bcd879bdb366e$var$machines) return $0a9bcd879bdb366e$var$machines[idName];
        if (parent !== name) {
            const parentMachine = $0a9bcd879bdb366e$export$109b76af3ca3e5d5(parent);
            if (parentMachine && parent in parentMachine.state) {
                const items = parentMachine.state[parent];
                const item = items.find((item)=>item.id === id);
                if (item) {
                    data = {
                        [child]: item
                    };
                    sync = true;
                    parentMachine.setSync(true);
                }
            }
        }
        $0a9bcd879bdb366e$var$machines[idName] = new $0a9bcd879bdb366e$var$Machine(idName, {
            ...$0a9bcd879bdb366e$var$machines[name].configuration
        }, id, data, sync);
        return $0a9bcd879bdb366e$var$machines[idName];
    }
    return $0a9bcd879bdb366e$var$machines[name];
}




function $92d14da6e77739da$export$2e2bcd8739ae039(data, keys) {
    return Object.fromEntries(Object.entries(data).filter(([key])=>keys.includes(key)));
}


function $5a08452fd7aaf8a1$export$2e2bcd8739ae039(name, id = null, reducer = false, persistent = true) {
    const machine = (0, $5OpyM$useMemo)(()=>(0, $0a9bcd879bdb366e$export$109b76af3ca3e5d5)(name, id), [
        name,
        id
    ]);
    if (!machine) throw new Error("Machine not found");
    if (reducer === false) return machine;
    const [state, setState] = (0, $5OpyM$useState)((0, $92d14da6e77739da$export$2e2bcd8739ae039)(machine.state, reducer));
    (0, $5OpyM$useEffect)(()=>{
        const subscription = machine.subscribe((newState)=>{
            const newData = (0, $92d14da6e77739da$export$2e2bcd8739ae039)(newState, reducer);
            if (Object.keys(newData).length) setState((oldState)=>({
                    ...oldState,
                    ...newData
                }));
        });
        return ()=>{
            subscription.unsubscribe();
            if (!persistent) machine.destroy();
        };
    }, []);
    return [
        state,
        machine
    ];
}




export {$0a9bcd879bdb366e$export$aaa7fa18f8e9b2e8 as createMachine, $0a9bcd879bdb366e$export$109b76af3ca3e5d5 as getMachine, $5a08452fd7aaf8a1$export$2e2bcd8739ae039 as useMachine};
//# sourceMappingURL=module.js.map
